import { render, staticRenderFns } from "./shphmasseuse.vue?vue&type=template&id=0a09e59c&scoped=true&"
import script from "./shphmasseuse.vue?vue&type=script&lang=js&"
export * from "./shphmasseuse.vue?vue&type=script&lang=js&"
import style0 from "./shphmasseuse.vue?vue&type=style&index=0&id=0a09e59c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a09e59c",
  null
  
)

export default component.exports